var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 173.8 39.6",
    style: {
      enableBackground: "new 0 0 173.8 39.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#040000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "109,10.7 118.5,4.5 113.5,0  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "107,12.9 94.9,6.3 99.7,1.1  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "169.3,38.8 162.5,25.6 168.8,14.6 162.1,14.6 158.5,22.6 158.5,14.6 152.2,14.6 152.2,38.8  158.5,38.8 158.5,30.2 162.3,38.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "83.1,38.8 76.3,25.6 82.5,14.6 75.9,14.6 72.3,22.6 72.3,14.6 66,14.6 66,38.8 72.3,38.8 72.3,30.2  76,38.8  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M96.4,19.9h-4.3V24H96v5.3h-3.9v4.2h4.3v5.3H85.9V14.6h10.6L96.4,19.9L96.4,19.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M110.2,19.9v18.9h-6.3V19.9h-2.8v-5.3h11.8v5.3H110.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M143.8,14.6v18.9h3.5v5.3h-9.8V14.6H143.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.3,38.8H0V14.6h7.6c2.7,0,5.4,0.6,7,2.3c1.6,1.6,2.2,3.6,2.2,6.2s-0.6,4.7-2.1,6.1 c-1.4,1.4-3.6,2.4-6.4,2.4h-2V38.8z M6.3,26.5h0.8c1.7,0,3.1-1.4,3.1-3.4S9,19.7,6.7,19.7H6.3V26.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M32.1,14c-7.1,0-12.8,5.7-12.8,12.8S25,39.6,32.1,39.6s12.8-5.7,12.8-12.8C44.8,19.7,39.1,14,32.1,14z  M32.1,33c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2s6.2,2.8,6.2,6.2S35.5,33,32.1,33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M60.5,33c-3.4,0-6.2-2.8-6.2-6.2s2.8-6.2,6.2-6.2V14c-7.1,0-12.8,5.7-12.8,12.8s5.7,12.8,12.8,12.8V33z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.7,38.8h6.6l-6.8-24.2h-1.1h-2.6h-1.1l-6.8,24.2h6.6l0.5-3.4h4.1L126.7,38.8z M122.8,30.6l1.3-7.9 l1.3,7.9H122.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M171.5,36.3h0.7c0.1,0,0.4,0,0.4,0.3s-0.2,0.4-0.4,0.4h-0.6L171.5,36.3L171.5,36.3z M171.5,37.2h0.7 c0.3,0,0.4,0.2,0.4,0.4c0,0.1,0,0.4,0,0.5h0.3l0,0c-0.1,0-0.1-0.1-0.1-0.2v-0.4c0-0.3-0.1-0.3-0.2-0.4c0.1-0.1,0.3-0.2,0.3-0.5 c0-0.4-0.3-0.5-0.7-0.5h-0.9v2h0.3v-0.9H171.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M170.2,37.1c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8s-0.8-1.8-1.8-1.8S170.2,36.1,170.2,37.1z M170.4,37.1 c0-0.8,0.7-1.5,1.5-1.5s1.5,0.7,1.5,1.5c0,0.9-0.7,1.5-1.5,1.5C171.1,38.6,170.4,38,170.4,37.1z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.edf1070065b60976e6c808a40840648b.svg";
export { ForwardRef as ReactComponent };